module.exports = __webpack_public_path__ + "img/47.3143ae4d.png";